import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: gives the order page an "Orders" crumb that links back to the list. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/orders')({
  staticData: { crumb: 'common:nav.orders' },
  component: Outlet,
});
